module.exports = "/_next/static/images/cell_2-9b135b7e69cca56026ab1a7f694df23f.png";